import { FC, PropsWithChildren } from 'react';
import { useLocation, useNavigate } from 'react-router';
import SidebarControl from './SidebarControl';

interface SidebarLinkProps extends PropsWithChildren {
  to: string;
  name?: string;
  className?: string;
  showOnPage?: boolean;
}

export const SidebarLink: FC<SidebarLinkProps> = ({ children, name, to, className, showOnPage = true }) => {
  const navigate = useNavigate();
  const location = useLocation();

  let classToDisplay = className;

  if (showOnPage && location.pathname === to) {
    classToDisplay += ' font-bold text-primary-900'
  }

  return (
    <SidebarControl onClickCallback={() => navigate(`${to}`)} name={name} className={classToDisplay}>
      {children}
    </SidebarControl>
  );
};
